import {createHttpLink} from 'apollo-link-http';

const httpLink = createHttpLink( {
    uri: upi.paths.ECOMMERCE_API
} );

export default httpLink;